import { useState } from 'react';
import { MessageCircle, Car } from 'lucide-react';
import { Reveal } from './Reveal';
import { services, waLink } from '../data/site';

export const Simulator = () => {
  const [name, setName] = useState('');
  const [plate, setPlate] = useState('');
  const [serviceId, setServiceId] = useState(services[0].id);
  const [error, setError] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (plate.trim().length < 7) {
      setError('Informe a placa completa (ex: ABC1D23).');
      return;
    }
    setError('');
    const service = services.find((s) => s.id === serviceId);
    const parts = [
      `Olá Davy!${name.trim() ? ` Meu nome é ${name.trim()}.` : ''}`,
      `Placa do veículo: ${plate.trim().toUpperCase()}.`,
      `Serviço: ${service.title}.`,
      'Pode me passar as informações?',
    ];
    window.open(waLink(parts.join(' ')), '_blank', 'noopener,noreferrer');
  };

  return (
    <section
      id="simulador"
      data-testid="simulator-section"
      className="relative py-24 sm:py-32 overflow-hidden bg-slate-50"
    >
      <div className="absolute -top-24 right-0 w-[500px] h-[500px] rounded-full bg-blue-100/70 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-600 mb-4">
            02 — Atendimento expresso
          </p>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight">
            Consulta de débitos e serviços{' '}
            <span className="text-blue-600">em 30 segundos.</span>
          </h2>
          <p className="mt-5 text-slate-500 text-sm sm:text-base max-w-md leading-relaxed">
            Preencha os dados do veículo e a mensagem chega pronta no meu
            WhatsApp. Sem cadastro, sem espera, sem formulário perdido.
          </p>
          <div className="mt-8 flex items-center gap-3 text-slate-500 text-xs font-mono uppercase tracking-[0.2em]">
            <Car size={16} className="text-blue-600" />
            Carros · Motos · Caminhonetes · Frota
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <form
            data-testid="simulator-form"
            onSubmit={submit}
            className="rounded-3xl border border-slate-200 bg-white p-7 sm:p-9 shadow-[0_30px_70px_-30px_rgba(15,23,42,0.25)]"
          >
            <div className="space-y-5">
              <div>
                <label className="block text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-2">
                  Seu nome (opcional)
                </label>
                <input
                  data-testid="simulator-name-input"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Como posso te chamar?"
                  className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-2">
                  Placa do veículo *
                </label>
                <input
                  data-testid="simulator-placa-input"
                  type="text"
                  value={plate}
                  onChange={(e) => setPlate(e.target.value.toUpperCase())}
                  placeholder="ABC1D23"
                  maxLength={8}
                  className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 font-mono text-base tracking-[0.2em] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-2">
                  Serviço desejado
                </label>
                <select
                  data-testid="simulator-service-select"
                  value={serviceId}
                  onChange={(e) => setServiceId(e.target.value)}
                  className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 text-sm text-slate-900 focus:outline-none focus:border-blue-500 transition-colors"
                >
                  {services.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.title}
                    </option>
                  ))}
                </select>
              </div>

              {error && (
                <p
                  data-testid="simulator-error"
                  className="text-xs text-red-500 font-medium"
                >
                  {error}
                </p>
              )}

              <button
                data-testid="simulator-submit-button"
                type="submit"
                className="w-full inline-flex items-center justify-center gap-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl px-6 py-4 text-sm sm:text-base transition-all duration-300 hover:shadow-[0_15px_40px_-10px_rgba(37,99,235,0.5)]"
              >
                <MessageCircle size={18} />
                Enviar consulta pelo WhatsApp
              </button>
              <p className="text-center text-[11px] text-slate-400">
                Você será redirecionado ao WhatsApp com a mensagem pronta.
              </p>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
